module.exports = __webpack_public_path__ + "static/media/tabula.5689c2d7.png";